import { render, staticRenderFns } from "./ReceivableList.vue?vue&type=template&id=6b9ff9fa&scoped=true&"
import script from "./ReceivableList.vue?vue&type=script&lang=js&"
export * from "./ReceivableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9ff9fa",
  null
  
)

export default component.exports